module.exports = __webpack_public_path__ + "static/media/gallery8.84cfd6bc.jpg";